import React from 'react';

export const Building = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
  >
    <path
      d="M9.25 44C8.55964 44 8 43.4404 8 42.75V8.25C8 5.90279 9.90279 4 12.25 4H27.75C30.0972 4 32 5.90279 32 8.25V19H35.75C38.0972 19 40 20.9028 40 23.25V42.75C40 43.4404 39.4404 44 38.75 44H9.25Z"
      fill="url(#paint0_linear_378174_8528)"
    />
    <path
      d="M34 37.25V44H24L23 40L24 35H31.75C32.9926 35 34 36.0074 34 37.25Z"
      fill="url(#paint1_linear_378174_8528)"
    />
    <path
      d="M14 37.25V44H24V35H16.25C15.0074 35 14 36.0074 14 37.25Z"
      fill="url(#paint2_linear_378174_8528)"
    />
    <path
      d="M18 14C18 15.1046 17.1046 16 16 16C14.8954 16 14 15.1046 14 14C14 12.8954 14.8954 12 16 12C17.1046 12 18 12.8954 18 14ZM16 23C17.1046 23 18 22.1046 18 21C18 19.8954 17.1046 19 16 19C14.8954 19 14 19.8954 14 21C14 22.1046 14.8954 23 16 23ZM18 28C18 29.1046 17.1046 30 16 30C14.8954 30 14 29.1046 14 28C14 26.8954 14.8954 26 16 26C17.1046 26 18 26.8954 18 28ZM24 16C25.1046 16 26 15.1046 26 14C26 12.8954 25.1046 12 24 12C22.8954 12 22 12.8954 22 14C22 15.1046 22.8954 16 24 16ZM26 21C26 22.1046 25.1046 23 24 23C22.8954 23 22 22.1046 22 21C22 19.8954 22.8954 19 24 19C25.1046 19 26 19.8954 26 21ZM24 30C25.1046 30 26 29.1046 26 28C26 26.8954 25.1046 26 24 26C22.8954 26 22 26.8954 22 28C22 29.1046 22.8954 30 24 30ZM34 28C34 29.1046 33.1046 30 32 30C30.8954 30 30 29.1046 30 28C30 26.8954 30.8954 26 32 26C33.1046 26 34 26.8954 34 28Z"
      fill="url(#paint3_linear_378174_8528)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_378174_8528"
        x1="8"
        y1="5.25"
        x2="46.1629"
        y2="44.3364"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#29C3FF" />
        <stop offset="1" stopColor="#2764E7" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_378174_8528"
        x1="24.375"
        y1="33.5714"
        x2="31.769"
        y2="41.8874"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0067BF" />
        <stop offset="1" stopColor="#003580" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_378174_8528"
        x1="14.3571"
        y1="36.875"
        x2="21.2584"
        y2="44.0451"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0067BF" />
        <stop offset="1" stopColor="#003580" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_378174_8528"
        x1="20"
        y1="10"
        x2="26"
        y2="34"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFDFD" />
        <stop offset="1" stopColor="#B3E0FF" />
      </linearGradient>
    </defs>
  </svg>
);
